import { Component, Input } from "@angular/core";

@Component({
    standalone: true,
    selector: "gene-reset-icon",
    templateUrl: "./reset-icon.component.html",
    styleUrls: ["./reset-icon.component.css"],
})
export class ResetIconComponent {
    @Input() width!: string;
    @Input() height!: string;
    @Input() color!: string;
}
